import { Button, Card, CircularProgress, Grid, Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { BackdropLoading } from '../../../../components';
import { delDataManajemen, getDetailDataManajemen } from '../../../../redux/actions/manajemenPerusahaanActions';

const DetailData = () => {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [params, setParams] = useState({
        name:"",
        img:"",
        img_ori: "",
        position_id:"",
        position_en:"",
        about_id:"",
        about_en:"",
        category:"",
        quote: "",
        quote_from: "",
        mg_code: ""
    });
    const showAlert = useCallback((text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then(res => {
            if(res.isConfirmed && success){
                history.goBack();
            }
        })
    }, [history]);
    const getData = useCallback(() => {
        setLoading(true);
        getDetailDataManajemen(id)
            .then((res) => {
                let data = res.data?.data;
                if (Object.keys(data).length > 0) {
                    setParams((pref) => ({
                        ...pref,
                        name: data?.name,
                        img: data?.img,
                        img_ori: data?.img_ori,
                        position_id: data?.position_id,
                        position_en: data?.position_en,
                        about_id: data?.about_id,
                        about_en: data?.about_en,
                        category: data?.category_id,
                        quote: data?.quote,
                        quote_from: data?.quote_from,
                        mg_code: data?.mg_code,
                    }));
                } else {
                    showAlert(
                        'Gagal mengambil detail data manajemen, coba beberapa saat lagi',
                        false
                    );
                }
                setLoading(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal mengambil detail data manajemen, coba beberapa saat lagi',
                    false
                );
                setLoading(false);
            });
    }, [id, showAlert]);
    useEffect(() => {
        setParams((pref) => ({
            ...pref,
            mg_code: id
        }));
        getData();
    }, [getData, id]);

    const handleDelete = (code, nama) => {
        Swal.fire({
            title: 'Konfirmasi Hapus',
            text: 'Apakah anda yakin ingin menghapus data ' + nama,
            imageUrl: `/assets/images/icons/ic_delete.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Hapus',
            confirmButtonColor: '#FD6D5D',
            showCancelButton: true,
            cancelButtonText: 'Batal',
            cancelButtonColor: '#0083E2',
            reverseButtons: true
        }).then((res) => {
            if (res.isConfirmed) {
                sendDelete(code);
            }
        });
    };

    const sendDelete = (code) => {
        setShowLoading(true);
        delDataManajemen(code)
            .then(() => {
                setShowLoading(false);
                showAlert('Berhasil menghapus data', true);
            })
            .catch((err) => {
                let error = err?.response?.data;
                setShowLoading(false);
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menghapus data, coba beberapa saat lagi',
                    false
                );
            });
    };
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={9}>
                    <h3 className="fw-bold m-0">Detail Manajemen Perusahaan</h3>
                </Grid>
                <Grid item xs={11} md={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Link to={`/data_manajemen/edit/${id}`} className="btn btn-outline-primary flex items-center border-radius-0 w-full">
                                <img
                                    src="/assets/images/icons/ic_action_edit.svg"
                                    alt="icon edit"
                                />
                                <span className="pl-4">
                                    {' '}
                                    Edit{' '}
                                </span>
                            </Link>
                        </Grid>
                        <Grid item xs={6}>
                            <Button onClick={() => handleDelete(params.mg_code, params.name)} variant="outlined" className='btn-outline-danger border-danger text-danger w-full'>
                                <img
                                    src="/assets/images/icons/ic_action_delete.svg"
                                    alt="icon delete"
                                />
                                <span className="pl-4">
                                    {' '}
                                    Delete{' '}
                                </span>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        {loading ? (
                            <div className="text-center">
                                <CircularProgress color="primary" size={35} />
                            </div>
                        ) : (
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <p className="mb-3 font-semibold text-16">Foto</p>
                                    <img src={params.img} alt={params.name} className="w-full" />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <p className="mb-3 font-semibold text-16">Nama</p>
                                            <p>{params.name}</p>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <p className="mb-3 font-semibold text-16">Kategori</p>
                                            <p>{params.category}</p>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <div className="mb-3 font-semibold text-16 d-flex items-center gap-1"><span>Jabatan [ID]</span>
                                                <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                    <InfoOutlined fontSize='default'></InfoOutlined>
                                                </Tooltip>
                                            </div>
                                            <p>{params.position_id}</p>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <div className="mb-3 font-semibold text-16 d-flex items-center gap-1"><span>Jabatan [EN]</span>
                                                <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                    <InfoOutlined fontSize='default'></InfoOutlined>
                                                </Tooltip>
                                            </div>
                                            <p>{params.position_en}</p>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <div className="mb-3 font-semibold text-16 d-flex items-center gap-1"><span>Deskripsi [ID]</span>
                                                <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                    <InfoOutlined fontSize='default'></InfoOutlined>
                                                </Tooltip>
                                            </div>
                                            <p className='whitespace-pre-wrap'>{params.about_id}</p>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <div className="mb-3 font-semibold text-16 d-flex items-center gap-1"><span>Deskripsi [EN]</span>
                                                <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                    <InfoOutlined fontSize='default'></InfoOutlined>
                                                </Tooltip>
                                            </div>
                                            <p className='whitespace-pre-wrap'>{params.about_en}</p>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <p className="mb-3 font-semibold text-16">Kutipan</p>
                                            <p>{params.quote}</p>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <p className="mb-3 font-semibold text-16">Pengutip</p>
                                            <p>{params.quote_from}</p>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </Card>
                </Grid>
            </Grid>
            <BackdropLoading open={showLoading} />
        </div>
    );
};

export default DetailData;
